import React from 'react';
import { motion } from 'framer-motion';
import { MailIcon, ClockIcon, UsersIcon } from 'lucide-react';
const painPoints = [{
  icon: <MailIcon className="h-8 w-8 text-brand-teal" data-id="element-185" />,
  title: 'Scattered tools and endless email threads',
  description: 'Stop jumping between different apps and losing track of important conversations buried in your inbox.'
}, {
  icon: <ClockIcon className="h-8 w-8 text-brand-teal" data-id="element-186" />,
  title: 'Missed client updates and deadlines',
  description: 'Never miss another deadline or important client message with centralised notifications and reminders.'
}, {
  icon: <UsersIcon className="h-8 w-8 text-brand-teal" data-id="element-187" />,
  title: 'Confused teams and duplicated effort',
  description: 'Eliminate confusion and wasted effort by keeping everyone on the same page with real-time updates.'
}];
export const PainPoints = () => {
  return <section className="py-16 bg-white" data-id="element-188">
      <div className="container-custom" data-id="element-189">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-190">
          <h2 className="text-3xl font-bold text-brand-blue mb-4" data-id="element-191">
            Common challenges teams face daily
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-192">
            Daily Serve solves the most frustrating parts of managing work
            across teams and clients.
          </p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-193">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-brand-light rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-194">
              <div className="mb-4" data-id="element-195">{point.icon}</div>
              <h3 className="text-xl font-semibold text-brand-blue mb-3" data-id="element-196">
                {point.title}
              </h3>
              <p className="text-gray-600" data-id="element-197">{point.description}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};